/**
 * Compares two dot-separated numeric version strings (e.g. '1.10.31') segment by segment.
 * Missing segments are treated as 0, so '1.6' is considered equal to '1.6.0'.
 *
 * @param {string} version - the version to test
 * @param {string} minimum - the version to compare against
 * @returns {boolean} true when `version` is strictly lower than `minimum`
 */
export const isVersionLower = (version: string, minimum: string): boolean => {
  const toSegments = (value: string) => value.split('.').map((part) => Number.parseInt(part, 10) || 0)

  const current = toSegments(version)
  const min = toSegments(minimum)
  const length = Math.max(current.length, min.length)

  for (let i = 0; i < length; i++) {
    const a = current[i] ?? 0
    const b = min[i] ?? 0

    if (a !== b) return a < b
  }

  return false
}
